import _maxBy from 'lodash/maxBy'

export const getMostRecentAppointment = (appointments) => {
  return _maxBy(
    appointments,
    (appointment) => new Date(appointment.scheduledOnTs)
  )
}
